import type { PropsWithChildren } from 'react';
import { useRef } from 'react';

import { nanoid } from 'nanoid'

import { type IModalProps, Modal } from '../Modal/Modal'

export interface IModalDialog {
  open: IModalProps['open']
  title: string
  maxWidth?: IModalProps['maxWidth']
  onClose?: IModalProps['onClose']
}

export const ModalDialog = ({
  open,
  title,
  maxWidth = 'md',
  children,
  onClose,
}: PropsWithChildren<IModalDialog>) => {
  const idRef = useRef<string>(nanoid())

  return (
    <Modal
      aria-labelledby={idRef.current}
      maxWidth={maxWidth}
      open={open}
      onClose={onClose}
      disableEnforceFocus
    >
      <Modal.Card>
        <Modal.Header id={idRef.current} onClose={onClose}>
          {title}
        </Modal.Header>
        <Modal.Content>{children}</Modal.Content>
      </Modal.Card>
    </Modal>
  )
}
